import { CALL_API } from 'store/middleware/api';
import isFormData from 'utils/type/isFormData';
import apiService from 'data/user/apiService';
import { selectCampaign } from './selectors';
import config from 'config';

const {
  constants: {
    API: { PRICING_UPDATE_URL },
  },
} = config;

const BALLPOINT_EMBED_TOKEN_TIMEOUT_MS = 15000;


export const LOAD_VOICEMAIL_CAMPAIGN = ('LOAD_VOICEMAIL_CAMPAIGN');
export const LOAD_CAMPAIGNS = ('LOAD_CAMPAIGNS');
export const LOAD_CAMPAIGNS_SUCCESS = ('LOAD_CAMPAIGNS_SUCCESS');
export const LOAD_CAMPAIGNS_ERROR = ('LOAD_CAMPAIGNS_ERROR');
export const LOAD_CAMPAIGN = ('LOAD_CAMPAIGN');
export const LOAD_CAMPAIGN_SUCCESS = ('LOAD_CAMPAIGN_SUCCESS');
export const LOAD_CAMPAIGN_ERROR = ('LOAD_CAMPAIGN_ERROR');
export const SAVE_CAMPAIGN = ('SAVE_CAMPAIGN');
export const SAVE_CAMPAIGN_SUCCESS = ('SAVE_CAMPAIGN_SUCCESS');
export const SAVE_CAMPAIGN_ERROR = ('SAVE_CAMPAIGN_ERROR');
export const CHECK_WEBSITE_AVAILABILITY = ('CHECK_WEBSITE_AVAILABILITY');
export const CHECK_WEBSITE_AVAILABILITY_SUCCESS = ('CHECK_WEBSITE_AVAILABILITY_SUCCESS');
export const CHECK_WEBSITE_AVAILABILITY_ERROR = ('CHECK_WEBSITE_AVAILABILITY_ERROR');
export const LOAD_WEBSITE_TEMPLATES = ('LOAD_WEBSITE_TEMPLATES');
export const LOAD_WEBSITE_TEMPLATES_SUCCESS = ('LOAD_WEBSITE_TEMPLATES_SUCCESS');
export const LOAD_WEBSITE_TEMPLATES_ERROR = ('LOAD_WEBSITE_TEMPLATES_ERROR');
export const SAVE_WEBSITE = ('SAVE_WEBSITE');
export const SAVE_WEBSITE_SUCCESS = ('SAVE_WEBSITE_SUCCESS');
export const SAVE_WEBSITE_ERROR = ('SAVE_WEBSITE_ERROR');
export const GET_VOICEMAIL_AUDIO_PIN = ('GET_VOICEMAIL_AUDIO_PIN_CAMPAIGNS');
export const GET_VOICEMAIL_AUDIO_PIN_SUCCESS = ('GET_VOICEMAIL_AUDIO_PIN_SUCCESS');
export const GET_VOICEMAIL_AUDIO_PIN_ERROR = ('GET_VOICEMAIL_AUDIO_PIN_ERROR');
export const LOAD_VOICEMAIL_CAMPAIGNS = ('LOAD_VOICEMAIL_CAMPAIGNS');
export const LOAD_VOICEMAIL_CAMPAIGNS_SUCCESS = ('LOAD_VOICEMAIL_CAMPAIGNS_SUCCESS');
export const LOAD_VOICEMAIL_CAMPAIGNS_ERROR = ('LOAD_VOICEMAIL_CAMPAIGNS_ERROR');
export const SAVE_VOICEMAIL_CAMPAIGN = ('SAVE_VOICEMAIL_CAMPAIGN');
export const SAVE_VOICEMAIL_CAMPAIGN_SUCCESS = ('SAVE_VOICEMAIL_CAMPAIGN_SUCCESS');
export const SAVE_VOICEMAIL_CAMPAIGN_ERROR = ('SAVE_VOICEMAIL_CAMPAIGN_ERROR');
export const PREVIEW_VOICEMAIL_CAMPAIGN = ('PREVIEW_VOICEMAIL_CAMPAIGN');
export const PREVIEW_VOICEMAIL_CAMPAIGN_SUCCESS = ('PREVIEW_VOICEMAIL_CAMPAIGN_SUCCESS');
export const PREVIEW_VOICEMAIL_CAMPAIGN_ERROR = ('PREVIEW_VOICEMAIL_CAMPAIGN_ERROR');
export const DELETE_VOICEMAIL_CAMPAIGN = ('DELETE_VOICEMAIL_CAMPAIGN');
export const DELETE_VOICEMAIL_CAMPAIGN_SUCCESS = ('DELETE_VOICEMAIL_CAMPAIGN_SUCCESS');
export const DELETE_VOICEMAIL_CAMPAIGN_ERROR = ('DELETE_VOICEMAIL_CAMPAIGN_ERROR');
export const LOAD_VOICEMAIL_CALLER_IDS = ('LOAD_VOICEMAIL_CALLER_IDS');
export const LOAD_VOICEMAIL_CALLER_IDS_SUCCESS = ('LOAD_VOICEMAIL_CALLER_IDS_SUCCESS');
export const LOAD_VOICEMAIL_CALLER_IDS_ERROR = ('LOAD_VOICEMAIL_CALLER_IDS_ERROR');
export const SAVE_VOICEMAIL_CALLER_ID = ('SAVE_VOICEMAIL_CALLER_ID');
export const SAVE_VOICEMAIL_CALLER_ID_SUCCESS = ('SAVE_VOICEMAIL_CALLER_ID_SUCCESS');
export const SAVE_VOICEMAIL_CALLER_ID_ERROR = ('SAVE_VOICEMAIL_CALLER_ID_ERROR');
export const DELETE_VOICEMAIL_CALLER_ID = ('DELETE_VOICEMAIL_CALLER_ID');
export const DELETE_VOICEMAIL_CALLER_ID_SUCCESS = ('DELETE_VOICEMAIL_CALLER_ID_SUCCESS');
export const DELETE_VOICEMAIL_CALLER_ID_ERROR = ('DELETE_VOICEMAIL_CALLER_ID_ERROR');
export const LOAD_VOICEMAIL_RECORDINGS = ('LOAD_VOICEMAIL_RECORDINGS');
export const LOAD_VOICEMAIL_RECORDINGS_SUCCESS = ('LOAD_VOICEMAIL_RECORDINGS_SUCCESS');
export const LOAD_VOICEMAIL_RECORDINGS_ERROR = ('LOAD_VOICEMAIL_RECORDINGS_ERROR');
export const SAVE_VOICEMAIL_RECORDING = ('SAVE_VOICEMAIL_RECORDING');
export const SAVE_VOICEMAIL_RECORDING_SUCCESS = ('SAVE_VOICEMAIL_RECORDING_SUCCESS');
export const SAVE_VOICEMAIL_RECORDING_ERROR = ('SAVE_VOICEMAIL_RECORDING_ERROR');
export const DELETE_VOICEMAIL_RECORDING = ('DELETE_VOICEMAIL_RECORDING');
export const DELETE_VOICEMAIL_RECORDING_SUCCESS = ('DELETE_VOICEMAIL_RECORDING_SUCCESS');
export const DELETE_VOICEMAIL_RECORDING_ERROR = ('DELETE_VOICEMAIL_RECORDING_ERROR');
export const LOAD_VOICEMAIL_SCHEDULES = ('LOAD_VOICEMAIL_SCHEDULES');
export const LOAD_VOICEMAIL_SCHEDULES_SUCCESS = ('LOAD_VOICEMAIL_SCHEDULES_SUCCESS');
export const LOAD_VOICEMAIL_SCHEDULES_ERROR = ('LOAD_VOICEMAIL_SCHEDULES_ERROR');
export const SAVE_VOICEMAIL_SCHEDULE = ('SAVE_VOICEMAIL_SCHEDULE');
export const SAVE_VOICEMAIL_SCHEDULE_SUCCESS = ('SAVE_VOICEMAIL_SCHEDULE_SUCCESS');
export const SAVE_VOICEMAIL_SCHEDULE_ERROR = ('SAVE_VOICEMAIL_SCHEDULE_ERROR');
export const DELETE_VOICEMAIL_SCHEDULE = ('DELETE_VOICEMAIL_SCHEDULE');
export const DELETE_VOICEMAIL_SCHEDULE_SUCCESS = ('DELETE_VOICEMAIL_SCHEDULE_SUCCESS');
export const DELETE_VOICEMAIL_SCHEDULE_ERROR = ('DELETE_VOICEMAIL_SCHEDULE_ERROR');
export const DOWNLOAD_VOICEMAIL_DETAIL = ('DOWNLOAD_VOICEMAIL_DETAIL');
export const DOWNLOAD_VOICEMAIL_DETAIL_SUCCESS = ('DOWNLOAD_VOICEMAIL_DETAIL_SUCCESS');
export const DOWNLOAD_VOICEMAIL_DETAIL_ERROR = ('DOWNLOAD_VOICEMAIL_DETAIL_ERROR');
export const VOICEMAIL_CAMPAIGN_CHANGE = ('VOICEMAIL_CAMPAIGN_CHANGE');

export const LOAD_POSTCARD_CAMPAIGN = ('LOAD_POSTCARD_CAMPAIGN');
export const LOAD_POSTCARD_CAMPAIGN_SUCCESS = ('LOAD_POSTCARD_CAMPAIGN_SUCCESS');
export const LOAD_POSTCARD_CAMPAIGN_ERROR = ('LOAD_POSTCARD_CAMPAIGN_ERROR');
export const GET_POSTCARD_CAMPAIGN = ('GET_POSTCARD_CAMPAIGN');
export const GET_POSTCARD_CAMPAIGN_SUCCESS = ('GET_POSTCARD_CAMPAIGN_SUCCESS');
export const GET_POSTCARD_CAMPAIGN_ERROR = ('GET_POSTCARD_CAMPAIGN_ERROR');
export const LOAD_POSTCARD_TEMPLATES = ('LOAD_POSTCARD_TEMPLATES');
export const LOAD_POSTCARD_TEMPLATES_SUCCESS = ('LOAD_POSTCARD_TEMPLATES_SUCCESS');
export const LOAD_POSTCARD_TEMPLATES_ERROR = ('LOAD_POSTCARD_TEMPLATES_ERROR');
export const SAVE_POSTCARD_CAMPAIGN = ('SAVE_POSTCARD_CAMPAIGN');
export const SAVE_POSTCARD_CAMPAIGN_SUCCESS = ('SAVE_POSTCARD_CAMPAIGN_SUCCESS');
export const SAVE_POSTCARD_CAMPAIGN_ERROR = ('SAVE_POSTCARD_CAMPAIGN_ERROR');
export const PREVIEW_POSTCARD_CAMPAIGN = ('PREVIEW_POSTCARD_CAMPAIGN');
export const PREVIEW_POSTCARD_CAMPAIGN_SUCCESS = ('PREVIEW_POSTCARD_CAMPAIGN_SUCCESS');
export const PREVIEW_POSTCARD_CAMPAIGN_ERROR = ('PREVIEW_POSTCARD_CAMPAIGN_ERROR');
export const DELETE_POSTCARD_CAMPAIGN = ('DELETE_POSTCARD_CAMPAIGN');
export const DELETE_POSTCARD_CAMPAIGN_SUCCESS = ('DELETE_POSTCARD_CAMPAIGN_SUCCESS');
export const DELETE_POSTCARD_CAMPAIGN_ERROR = ('DELETE_POSTCARD_CAMPAIGN_ERROR');
export const DOWNLOAD_POSTCARD_CAMPAIGN_PDF = ('DOWNLOAD_POSTCARD_CAMPAIGN_PDF');
export const DOWNLOAD_POSTCARD_CAMPAIGN_PDF_SUCCESS = ('DOWNLOAD_POSTCARD_CAMPAIGN_PDF_SUCCESS');
export const DOWNLOAD_POSTCARD_CAMPAIGN_PDF_ERROR = ('DOWNLOAD_POSTCARD_CAMPAIGN_PDF_ERROR');
export const DOWNLOAD_POSTCARD_DETAIL = ('DOWNLOAD_POSTCARD_DETAIL');
export const DOWNLOAD_POSTCARD_DETAIL_SUCCESS = ('DOWNLOAD_POSTCARD_DETAIL_SUCCESS');
export const DOWNLOAD_POSTCARD_DETAIL_ERROR = ('DOWNLOAD_POSTCARD_DETAIL_ERROR');
export const CLEAR_POSTCARD_CAMPAIGN = ('CLEAR_POSTCARD_CAMPAIGN');
export const POSTCARD_CAMPAIGN_CHANGE = ('POSTCARD_CAMPAIGN_CHANGE');
export const UPDATE_WEBSITE = ('UPDATE_WEBSITE');
export const LOAD_WEBSITE = ('LOAD_WEBSITE');
export const GENERATE_MAILING_LABELS = ('GENERATE_MAILING_LABELS');
export const GENERATE_MAILING_LABELS_SUCCESS = ('GENERATE_MAILING_LABELS_SUCCESS');
export const GENERATE_MAILING_LABELS_ERROR = ('GENERATE_MAILING_LABELS_ERROR');
export const SET_NOTES_DIRTY = ('SET_NOTES_DIRTY');
export const RESET_NOTES_DIRTY = ('RESET_NOTES_DIRTY');


export const DOWNLOAD_DIALER_CAMPAIGN_REPORT = ('DOWNLOAD_DIALER_CAMPAIGN_REPORT');
export const DOWNLOAD_DIALER_CAMPAIGN_REPORT_SUCCESS = ('DOWNLOAD_DIALER_CAMPAIGN_REPORT_SUCCESS');
export const DOWNLOAD_DIALER_CAMPAIGN_REPORT_ERROR = ('DOWNLOAD_DIALER_CAMPAIGN_REPORT_ERROR');

export const END_DIALER_CAMPAIGN = ('END_DIALER_CAMPAIGN');
export const END_DIALER_CAMPAIGN_SUCCESS = ('END_DIALER_CAMPAIGN_SUCCESS');
export const END_DIALER_CAMPAIGN_ERROR = ('END_DIALER_CAMPAIGN_ERROR');

export const LOAD_DIRECT_MAIL_PIECE_COUNTS = 'LOAD_DIRECT_MAIL_PIECE_COUNTS';
export const LOAD_DIRECT_MAIL_PIECE_COUNTS_SUCCESS = 'LOAD_DIRECT_MAIL_PIECE_COUNTS_SUCCESS';
export const LOAD_DIRECT_MAIL_PIECE_COUNTS_ERROR = 'LOAD_DIRECT_MAIL_PIECE_COUNTS_ERROR';


export const LOAD_DIRECT_MAIL_COST_PREVIEW = 'LOAD_DIRECT_MAIL_COST_PREVIEW';
export const LOAD_DIRECT_MAIL_COST_PREVIEW_SUCCESS = 'LOAD_DIRECT_MAIL_COST_PREVIEW_SUCCESS';
export const LOAD_DIRECT_MAIL_COST_PREVIEW_ERROR = 'LOAD_DIRECT_MAIL_COST_PREVIEW_ERROR';


function mapToObj(map) {
  const obj = {}
  for (let [k, v] of map)
    obj[k] = v
  return obj
}

function marketing(type, method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, download = false, query, skipGlobalErrorHandler } = {}) {
  return {
    [CALL_API]: {
      method,
      startType,
      successType,
      errorType,
      body: body ? (typeof body === 'object' && body.hasOwnProperty('__altered') ? JSON.stringify(mapToObj(body)) : body) : null,
      afterSuccess,
      afterError,
      successParams,
      query,
      download,
      skipGlobalErrorHandler,
      path: `/resource/auth/ps4/user/marketing${type ? `/${type}` : ''}${path ? `/${path}` : ''}`,
      // ...(method === 'post' && !isFormData(body) ? { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } : {}),
      headers: { 'Content-Type': 'application/json' }
    },
  };
}

function contact(method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, download = false, query } = {}) {
  return {
    [CALL_API]: {
      method,
      startType,
      successType,
      errorType,
      body: body ? (typeof body === 'object' && body.hasOwnProperty('__altered') ? JSON.stringify(mapToObj(body)) : body) : null,
      afterSuccess,
      afterError,
      successParams,
      query,
      download,
      path: `/resource/auth/ps4/user/contacts${path ? `/${path}` : ''}`,
      headers: { 'Content-Type': 'application/json' }
    },
  };
}

function marketingSave(type, method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, download = false, query } = {}) {
  return {
    [CALL_API]: {
      method,
      startType,
      successType,
      errorType,
      body,
      afterSuccess,
      afterError,
      successParams,
      query,
      download,
      path: `/resource/auth/ps4/user/marketing${type ? `/${type}` : ''}${path ? `/${path}` : ''}`,
    },
  };
}

function dialer(method, path, startType, successType, errorType, body, {
  afterSuccess,
  afterError,
  successParams,
  download = false,
  query
} = {}) {
  return {
    [CALL_API]: {
      method,
      startType,
      successType,
      errorType,
      body: body ? (typeof body === 'object' && body.hasOwnProperty('__altered') ? JSON.stringify(mapToObj(body)) : body) : null,
      afterSuccess,
      afterError,
      successParams,
      query,
      download,
      path,
      headers: { 'Content-Type': 'application/json' }
    },
  };
}

export const downloadDialerCampaignReport = dialerCampaignId => dialer('get', `/resource/auth/ps4/user/marketing/dialer/campaigns/${dialerCampaignId}/export`,
  DOWNLOAD_DIALER_CAMPAIGN_REPORT, DOWNLOAD_DIALER_CAMPAIGN_REPORT_SUCCESS, DOWNLOAD_DIALER_CAMPAIGN_REPORT_ERROR, null, { download: true });

export const endDialerCampaign = dialerCampaignId => dialer('delete', `/resource/auth/ps4/user/marketing/dialer/campaigns/${dialerCampaignId}/end`,
  END_DIALER_CAMPAIGN, END_DIALER_CAMPAIGN_SUCCESS, END_DIALER_CAMPAIGN_ERROR, null, { download: false });

export const loadCampaigns = () => marketing(null, 'get', null, LOAD_CAMPAIGNS, LOAD_CAMPAIGNS_SUCCESS, LOAD_CAMPAIGNS_ERROR);

export const loadCampaign = (id, afterSuccess) => marketing(null, 'get', id, LOAD_CAMPAIGN, LOAD_CAMPAIGN_SUCCESS, LOAD_CAMPAIGN_ERROR, null, { afterSuccess });

export const saveCampaign = (campaign, afterSuccess, afterError) =>
  marketing(null, 'put', null, SAVE_CAMPAIGN, SAVE_CAMPAIGN_SUCCESS, SAVE_CAMPAIGN_ERROR, campaign, { afterSuccess, afterError });

export const checkWebsiteAvailability = (id, path, afterSuccess) => marketing(null, 'get', `website/check${id ? `/${id}` : ''}/${path}`, CHECK_WEBSITE_AVAILABILITY, CHECK_WEBSITE_AVAILABILITY_SUCCESS, CHECK_WEBSITE_AVAILABILITY_ERROR, null, { afterSuccess });

export const saveWebsite = (id, website, afterSuccess) => marketing(null, 'put', `${id}/website`, SAVE_WEBSITE, SAVE_WEBSITE_SUCCESS, SAVE_WEBSITE_ERROR, website, { afterSuccess });

export const loadWebsiteTemplates = () => marketing(null, 'get', 'website/templates', LOAD_WEBSITE_TEMPLATES, LOAD_WEBSITE_TEMPLATES_SUCCESS, LOAD_WEBSITE_TEMPLATES_ERROR);

const voicemail = (method, path, startType, successType, errorType, body, params) => marketing('voicemail', method, path, startType, successType, errorType, body, params);

const postcard = (method, path, startType, successType, errorType, body, params) => marketingSave('postcard', method, path, startType, successType, errorType, body, params);

export const loadVoicemailCampaign = id => ({ type: LOAD_VOICEMAIL_CAMPAIGN, id });

export const getVoicemailAudioPin = (create, afterSuccess) => voicemail('get', 'audiopin', GET_VOICEMAIL_AUDIO_PIN, GET_VOICEMAIL_AUDIO_PIN_SUCCESS, GET_VOICEMAIL_AUDIO_PIN_ERROR, null, { afterSuccess, query: { create } });

export const loadVoicemailCampaigns = () => voicemail('get', 'campaigns', LOAD_VOICEMAIL_CAMPAIGNS, LOAD_VOICEMAIL_CAMPAIGNS_SUCCESS, LOAD_VOICEMAIL_CAMPAIGNS_ERROR);

export const saveVoicemailCampaign = (campaign, duplicate, paymentMethodId, cardCode, creditAmount, paymentAmount, afterSuccess) => voicemail('put', 'campaigns', SAVE_VOICEMAIL_CAMPAIGN, SAVE_VOICEMAIL_CAMPAIGN_SUCCESS, SAVE_VOICEMAIL_CAMPAIGN_ERROR, campaign, { afterSuccess, query: { duplicate, paymentMethodId, cardCode, creditAmount, paymentAmount } });

export const previewVoicemailCampaign = (campaign, estimate, afterSuccess) => voicemail('post', 'preview', PREVIEW_VOICEMAIL_CAMPAIGN, PREVIEW_VOICEMAIL_CAMPAIGN_SUCCESS, PREVIEW_VOICEMAIL_CAMPAIGN_ERROR, campaign, { afterSuccess, query: { estimate } });

export const deleteVoicemailCampaign = id => voicemail('delete', `campaigns/${id}`, DELETE_VOICEMAIL_CAMPAIGN, DELETE_VOICEMAIL_CAMPAIGN_SUCCESS, DELETE_VOICEMAIL_CAMPAIGN_ERROR);

export const loadVoicemailCallerIds = () => voicemail('get', 'callerids', LOAD_VOICEMAIL_CALLER_IDS, LOAD_VOICEMAIL_CALLER_IDS_SUCCESS, LOAD_VOICEMAIL_CALLER_IDS_ERROR);

export const saveVoicemailCallerId = phone => voicemail('post', 'callerids', SAVE_VOICEMAIL_CALLER_ID, SAVE_VOICEMAIL_CALLER_ID_SUCCESS, SAVE_VOICEMAIL_CALLER_ID_ERROR, { phone });

export const deleteVoicemailCallerId = id => voicemail('delete', `callerids/${id}`, DELETE_VOICEMAIL_CALLER_ID, DELETE_VOICEMAIL_CALLER_ID_SUCCESS, DELETE_VOICEMAIL_CALLER_ID_ERROR);

export const loadVoicemailRecordings = () => voicemail('get', 'recordings', LOAD_VOICEMAIL_RECORDINGS, LOAD_VOICEMAIL_RECORDINGS_SUCCESS, LOAD_VOICEMAIL_RECORDINGS_ERROR);

export const saveVoicemailRecording = recording => voicemail(isFormData(recording) ? 'post' : 'put', 'recordings', SAVE_VOICEMAIL_RECORDING, SAVE_VOICEMAIL_RECORDING_SUCCESS, SAVE_VOICEMAIL_RECORDING_ERROR, recording);

export const deleteVoicemailRecording = id => voicemail('delete', `recordings/${id}`, DELETE_VOICEMAIL_RECORDING, DELETE_VOICEMAIL_RECORDING_SUCCESS, DELETE_VOICEMAIL_RECORDING_ERROR);

export const loadVoicemailSchedules = () => voicemail('get', 'schedules', LOAD_VOICEMAIL_SCHEDULES, LOAD_VOICEMAIL_SCHEDULES_SUCCESS, LOAD_VOICEMAIL_SCHEDULES_ERROR);

export const saveVoicemailSchedule = schedule => voicemail('put', 'schedules', SAVE_VOICEMAIL_SCHEDULE, SAVE_VOICEMAIL_SCHEDULE_SUCCESS, SAVE_VOICEMAIL_SCHEDULE_ERROR, schedule);

export const deleteVoicemailSchedule = id => voicemail('delete', `schedules/${id}`, DELETE_VOICEMAIL_SCHEDULE, DELETE_VOICEMAIL_SCHEDULE_SUCCESS, DELETE_VOICEMAIL_SCHEDULE_ERROR);

export const downloadVoicemailDetail = id => voicemail('get', `${id}/detail`, DOWNLOAD_VOICEMAIL_DETAIL, DOWNLOAD_VOICEMAIL_DETAIL_SUCCESS, DOWNLOAD_VOICEMAIL_DETAIL_ERROR, null, { download: true });

export const voicemailCampaignChange = (name, value) => ({ type: VOICEMAIL_CAMPAIGN_CHANGE, name, value });

export const loadPostcardCampaign = id => (id > 0 ? postcard('get', `campaigns/${id}`, LOAD_POSTCARD_CAMPAIGN, LOAD_POSTCARD_CAMPAIGN_SUCCESS, LOAD_POSTCARD_CAMPAIGN_ERROR) : { type: CLEAR_POSTCARD_CAMPAIGN });

export const getPostcardCampaign = (id, afterSuccess) => postcard('get', `campaigns/${id}`, GET_POSTCARD_CAMPAIGN, GET_POSTCARD_CAMPAIGN_SUCCESS, GET_POSTCARD_CAMPAIGN_ERROR, null, { afterSuccess });

export const loadPostcardTemplates = () => postcard('get', 'templatesnew', LOAD_POSTCARD_TEMPLATES, LOAD_POSTCARD_TEMPLATES_SUCCESS, LOAD_POSTCARD_TEMPLATES_ERROR);

export const savePostcardCampaign = (campaign, duplicate, paymentMethodId, cardCode, paymentAmount, creditAmount, afterSuccess) => postcard('put', 'campaigns/new', SAVE_POSTCARD_CAMPAIGN, SAVE_POSTCARD_CAMPAIGN_SUCCESS, SAVE_POSTCARD_CAMPAIGN_ERROR, campaign, { afterSuccess, query: { duplicate, paymentMethodId, cardCode, paymentAmount, creditAmount } });

export const previewPostcardCampaign = (campaign, estimate, afterSuccess) => postcard('post', 'preview', PREVIEW_POSTCARD_CAMPAIGN, PREVIEW_POSTCARD_CAMPAIGN_SUCCESS, PREVIEW_POSTCARD_CAMPAIGN_ERROR, campaign, { afterSuccess, query: { estimate } });

export const downloadPostcardCampaignPdf = campaign => postcard('post', 'pdf', DOWNLOAD_POSTCARD_CAMPAIGN_PDF, DOWNLOAD_POSTCARD_CAMPAIGN_PDF_SUCCESS, DOWNLOAD_POSTCARD_CAMPAIGN_PDF_ERROR, campaign, { download: true });

export const downloadPostcardCampaignPdfById = id => postcard('get', `pdf/${id}`, DOWNLOAD_POSTCARD_CAMPAIGN_PDF, DOWNLOAD_POSTCARD_CAMPAIGN_PDF_SUCCESS, DOWNLOAD_POSTCARD_CAMPAIGN_PDF_ERROR, null, { download: true });

export const deletePostcardCampaign = id => postcard('delete', `campaigns/${id}`, DELETE_POSTCARD_CAMPAIGN, DELETE_POSTCARD_CAMPAIGN_SUCCESS, DELETE_POSTCARD_CAMPAIGN_ERROR);

export const downloadPostcardDetail = id => postcard('get', `${id}/detail`, DOWNLOAD_POSTCARD_DETAIL, DOWNLOAD_POSTCARD_DETAIL_SUCCESS, DOWNLOAD_POSTCARD_DETAIL_ERROR, null, { download: true });

export const postcardCampaignChange = (name, value) => ({ type: POSTCARD_CAMPAIGN_CHANGE, name, value });

export const generatePropertyMailingLabels = (layoutId, offset, format, propertySearch, afterSuccess) => marketing(null, 'post', 'mailinglabels/properties', GENERATE_MAILING_LABELS, GENERATE_MAILING_LABELS_SUCCESS, GENERATE_MAILING_LABELS_ERROR, propertySearch, { afterSuccess, download: true, query: { layoutId, offset, format } });
export const generateContactMailingLabels = (layoutId, offset, format, contactSearch, afterSuccess) => marketing(null, 'post', 'mailinglabels/contacts', GENERATE_MAILING_LABELS, GENERATE_MAILING_LABELS_SUCCESS, GENERATE_MAILING_LABELS_ERROR, contactSearch, { afterSuccess, download: true, query: { layoutId, offset, format } });


export const CLEAR_EMAIL_CAMPAIGN = ('CLEAR_EMAIL_CAMPAIGN');
export const SAVE_EMAIL_CAMPAIGN = ('SAVE_EMAIL_CAMPAIGN');
export const SAVE_EMAIL_CAMPAIGN_SUCCESS = ('SAVE_EMAIL_CAMPAIGN_SUCCESS');
export const SAVE_EMAIL_CAMPAIGN_ERROR = ('SAVE_EMAIL_CAMPAIGN_ERROR');
export const PREVIEW_EMAIL_CAMPAIGN = ('PREVIEW_EMAIL_CAMPAIGN');
export const PREVIEW_EMAIL_CAMPAIGN_SUCCESS = ('PREVIEW_EMAIL_CAMPAIGN_SUCCESS');
export const PREVIEW_EMAIL_CAMPAIGN_ERROR = ('PREVIEW_EMAIL_CAMPAIGN_ERROR');
export const DELETE_EMAIL_CAMPAIGN = ('DELETE_EMAIL_CAMPAIGN');
export const DELETE_EMAIL_CAMPAIGN_SUCCESS = ('DELETE_EMAIL_CAMPAIGN_SUCCESS');
export const DELETE_EMAIL_CAMPAIGN_ERROR = ('DELETE_EMAIL_CAMPAIGN_ERROR');
export const LOAD_EMAIL_CAMPAIGN = ('LOAD_EMAIL_CAMPAIGN');
export const LOAD_EMAIL_CAMPAIGN_ERROR = ('LOAD_EMAIL_CAMPAIGN_ERROR');
export const LOAD_EMAIL_CAMPAIGN_SUCCESS = ('LOAD_EMAIL_CAMPAIGN_SUCCESS');
export const LOAD_EMAIL_TEMPLATES = ('LOAD_EMAIL_TEMPLATES');
export const LOAD_EMAIL_TEMPLATES_ERROR = ('LOAD_EMAIL_TEMPLATES_ERROR');
export const LOAD_EMAIL_TEMPLATES_SUCCESS = ('LOAD_EMAIL_TEMPLATES_SUCCESS');
export const UPDATE_EMAIL_CAMPAIGN = ('UPDATE_EMAIL_CAMPAIGN');
export const CHECK_URL_VALIDITY = ('CHECK_URL_VALIDITY');
export const CHECK_URL_VALIDITY_SUCCESS = ('CHECK_URL_VALIDITY_SUCCESS');
export const CHECK_URL_VALIDITY_ERROR = ('CHECK_URL_VALIDITY_ERROR');
export const DOWNLOAD_EMAIL_DETAIL = ('DOWNLOAD_EMAIL_DETAIL');
export const DOWNLOAD_EMAIL_DETAIL_SUCCESS = ('DOWNLOAD_EMAIL_DETAIL_SUCCESS');
export const DOWNLOAD_EMAIL_DETAIL_ERROR = ('DOWNLOAD_EMAIL_DETAIL_ERROR');

const email = (method, path, startType, successType, errorType, body, params) => marketing('email', method, path, startType, successType, errorType, body, params);

export const loadEmailCampaign = id => (id > 0 ? email('get', id, LOAD_EMAIL_CAMPAIGN, LOAD_EMAIL_CAMPAIGN_SUCCESS, LOAD_EMAIL_CAMPAIGN_ERROR) : { type: CLEAR_EMAIL_CAMPAIGN });

export const loadEmailTemplates = () => email('get', 'templates', LOAD_EMAIL_TEMPLATES, LOAD_EMAIL_TEMPLATES_SUCCESS, LOAD_EMAIL_TEMPLATES_ERROR);

export const saveEmailCampaign = (campaign, duplicate, paymentMethodId, cardCode, paymentAmount, creditAmount, afterSuccess) => email('put', null, SAVE_EMAIL_CAMPAIGN, SAVE_EMAIL_CAMPAIGN_SUCCESS, SAVE_EMAIL_CAMPAIGN_ERROR, campaign, { afterSuccess, query: { duplicate, paymentMethodId, cardCode, paymentAmount, creditAmount } });

export const previewEmailCampaign = (campaign, previewEmail, estimate, afterSuccess) => email('post', 'preview', PREVIEW_EMAIL_CAMPAIGN, PREVIEW_EMAIL_CAMPAIGN_SUCCESS, PREVIEW_EMAIL_CAMPAIGN_ERROR, campaign.merge({ previewEmail }), { afterSuccess, query: { estimate } });

export const deleteEmailCampaign = id => email('delete', `campaigns/${id}`, DELETE_EMAIL_CAMPAIGN, DELETE_EMAIL_CAMPAIGN_SUCCESS, DELETE_EMAIL_CAMPAIGN_ERROR);

export const updateEmailCampaign = campaign => ({ type: UPDATE_EMAIL_CAMPAIGN, campaign });

export const updateWebsite = website => ({ type: UPDATE_WEBSITE, website });

export const loadWebsite = () => ({ type: LOAD_WEBSITE });

export const checkUrlValidity = (url, afterSuccess) => email('get', 'url', CHECK_URL_VALIDITY, CHECK_URL_VALIDITY_SUCCESS, CHECK_URL_VALIDITY_ERROR, null, { afterSuccess, query: { url } });

export const downloadEmailDetail = id => email('get', `${id}/detail`, DOWNLOAD_EMAIL_DETAIL, DOWNLOAD_EMAIL_DETAIL_SUCCESS, DOWNLOAD_EMAIL_DETAIL_ERROR, null, { download: true });


export const GET_SMS_STATUS = ('GET_SMS_STATUS');
export const GET_SMS_STATUS_SUCCESS = ('GET_SMS_STATUS_SUCCESS');
export const GET_SMS_STATUS_ERROR = ('GET_SMS_STATUS_ERROR');
export const GET_SMS_LOGIN = ('GET_SMS_LOGIN');
export const GET_SMS_LOGIN_SUCCESS = ('GET_SMS_LOGIN_SUCCESS');
export const GET_SMS_LOGIN_ERROR = ('GET_SMS_LOGIN_ERROR');
export const CREATE_SMS_CAMPAIGN = ('CREATE_SMS_CAMPAIGN');
export const CREATE_SMS_CAMPAIGN_SUCCESS = ('CREATE_SMS_CAMPAIGN_SUCCESS');
export const CREATE_SMS_CAMPAIGN_ERROR = ('CREATE_SMS_CAMPAIGN_ERROR');

const sms = (method, path, startType, successType, errorType, body, params) => marketing('sms', method, path, startType, successType, errorType, body, params);

export const getSmsStatus = () => sms('get', 'status', GET_SMS_STATUS, GET_SMS_STATUS_SUCCESS, GET_SMS_STATUS_ERROR);

export const getSmsLogin = afterSuccess => sms('get', 'login', GET_SMS_LOGIN, GET_SMS_LOGIN_SUCCESS, GET_SMS_LOGIN_ERROR, null, { afterSuccess });

export const createSmsCampaign = (search, afterSuccess) => sms('post', null, CREATE_SMS_CAMPAIGN, CREATE_SMS_CAMPAIGN_SUCCESS, CREATE_SMS_CAMPAIGN_ERROR, search, { afterSuccess });
export const setNotesDirty = isDirty => ({
  type: SET_NOTES_DIRTY,
  isDirty,
});

export const resetNotesDirty = () => ({
  type: RESET_NOTES_DIRTY,
});


// Dialer Campaign

export const LOAD_DIALER_CAMPAIGN_LEADS = ('LOAD_DIALER_CAMPAIGN_LEADS');
export const LOAD_DIALER_CAMPAIGN_LEADS_SUCCESS = ('LOAD_DIALER_CAMPAIGN_LEADS_SUCCESS');
export const LOAD_AND_APPEND_DIALER_CAMPAIGN_LEADS_SUCCESS = ('LOAD_AND_APPEND_DIALER_CAMPAIGN_LEADS_SUCCESS');
export const LOAD_DIALER_CAMPAIGN_LEADS_ERROR = ('LOAD_DIALER_CAMPAIGN_LEADS_ERROR');

export const LOAD_DIALER_CAMPAIGN_DETAILS = ('LOAD_DIALER_CAMPAIGN_DETAILS');
export const LOAD_DIALER_CAMPAIGN_DETAILS_SUCCESS = ('LOAD_DIALER_CAMPAIGN_DETAILS_SUCCESS');
export const LOAD_DIALER_CAMPAIGN_DETAILS_ERROR = ('LOAD_DIALER_CAMPAIGN_DETAILS_ERROR');

const dialerMarketing = (method, path, startType, successType, errorType, body, params) => marketing('dialer', method, path, startType, successType, errorType, body, params);

export const loadDialerCampaignDetails = id => dialerMarketing('get', `campaigns/${id}`, LOAD_DIALER_CAMPAIGN_DETAILS, LOAD_DIALER_CAMPAIGN_DETAILS_SUCCESS, LOAD_DIALER_CAMPAIGN_DETAILS_ERROR);

export const loadDialerCampaignLeads = (campaignId, limit, offset, isAppend = false) =>
  dialerMarketing('get', `campaigns/${campaignId}/leads`, LOAD_DIALER_CAMPAIGN_LEADS, !isAppend ? LOAD_DIALER_CAMPAIGN_LEADS_SUCCESS : LOAD_AND_APPEND_DIALER_CAMPAIGN_LEADS_SUCCESS,
    LOAD_DIALER_CAMPAIGN_LEADS_ERROR, null, { query: { limit, offset } });

// Direct Mail Campaign

export const LOAD_DIRECT_MAIL_CAMPAIGN = ('LOAD_DIRECT_MAIL_CAMPAIGN');
export const LOAD_DIRECT_MAIL_CAMPAIGN_SUCCESS = ('LOAD_DIRECT_MAIL_CAMPAIGN_SUCCESS');
export const LOAD_DIRECT_MAIL_CAMPAIGN_ERROR = ('LOAD_DIRECT_MAIL_CAMPAIGN_ERROR');

export const CREATE_DIRECT_MAIL_CAMPAIGN = ('CREATE_DIRECT_MAIL_CAMPAIGN');
export const CREATE_DIRECT_MAIL_CAMPAIGN_SUCCESS = ('CREATE_DIRECT_MAIL_CAMPAIGN_SUCCESS');
export const CREATE_DIRECT_MAIL_CAMPAIGN_ERROR = ('CREATE_DIRECT_MAIL_CAMPAIGN_ERROR');

export const UPDATE_DIRECT_MAIL_CAMPAIGN = ('UPDATE_DIRECT_MAIL_CAMPAIGN');
export const UPDATE_DIRECT_MAIL_CAMPAIGN_SUCCESS = ('UPDATE_DIRECT_MAIL_CAMPAIGN_SUCCESS');
export const UPDATE_DIRECT_MAIL_CAMPAIGN_ERROR = ('UPDATE_DIRECT_MAIL_CAMPAIGN_ERROR');

export const LOAD_DIRECT_MAIL_CAMPAIGN_STATS = ('LOAD_DIRECT_MAIL_CAMPAIGN_STATS');
export const LOAD_DIRECT_MAIL_CAMPAIGN_STATS_SUCCESS = ('LOAD_DIRECT_MAIL_CAMPAIGN_STATS_SUCCESS');
export const LOAD_DIRECT_MAIL_CAMPAIGN_STATS_ERROR = ('LOAD_DIRECT_MAIL_CAMPAIGN_STATS_ERROR');

export const CREATE_DIRECT_MAIL_CAMPAIGN_ORDER = ('CREATE_DIRECT_MAIL_CAMPAIGN_ORDER');
export const CREATE_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS = ('CREATE_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS');
export const CREATE_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR = ('CREATE_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR');

export const LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID = ('LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID');
export const LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID_SUCCESS = ('LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID_SUCCESS');
export const LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID_ERROR = ('LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID_ERROR');

export const LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER = ('LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER');
export const LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER_SUCCESS = ('LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER_SUCCESS');
export const LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER_ERROR = ('LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER_ERROR');

export const UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER = ('UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER');
export const UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS = ('UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS');
export const UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR = ('UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR');

export const CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION = ('CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION');
export const CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION_SUCCESS = ('CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION_SUCCESS');
export const CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION_ERROR = ('CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION_ERROR');

export const CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER = ('CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER');
export const CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS = ('CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS');
export const CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR = ('CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR');

export const SAVE_DIRECT_MAIL_CAMPAIGN_RTS = ('SAVE_DIRECT_MAIL_CAMPAIGN_RTS');
export const SAVE_DIRECT_MAIL_CAMPAIGN_RTS_SUCCESS = ('SAVE_DIRECT_MAIL_CAMPAIGN_RTS_SUCCESS');
export const SAVE_DIRECT_MAIL_CAMPAIGN_RTS_ERROR = ('SAVE_DIRECT_MAIL_CAMPAIGN_RTS_ERROR');

export const UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS = ('UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS');
export const UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS_SUCCESS = ('UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS_SUCCESS');
export const UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS_ERROR = ('UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS_ERROR');

export const DIRECT_MAIL_CONTACT_OPTOUT = ('DIRECT_MAIL_CONTACT_OPTOUT');
export const DIRECT_MAIL_CONTACT_OPTOUT_SUCCESS = ('DIRECT_MAIL_CONTACT_OPTOUT_SUCCESS');
export const DIRECT_MAIL_CONTACT_OPTOUT_ERROR = ('DIRECT_MAIL_CONTACT_OPTOUT_ERROR');

export const loadDirectMailCampaignStats = (campaignId) => ({
  type: LOAD_DIRECT_MAIL_CAMPAIGN_STATS,
  campaignId,
});

export const loadDirectMailCampaignStatsSuccess = (payload, campaignId) => ({
  type: LOAD_DIRECT_MAIL_CAMPAIGN_STATS_SUCCESS,
  payload,
  campaignId,
});

export const loadDirectMailCampaignStatsError = (payload, campaignId) => ({
  type: LOAD_DIRECT_MAIL_CAMPAIGN_STATS_ERROR,
  payload,
  campaignId,
});

export const loadDirectMailCampaignBallpointOrderSuccess = (payload) => ({
  type: LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER_SUCCESS,
  payload,
});

export const loadDirectMailCampaignBallpointOrderError = (payload) => ({
  type: LOAD_DIRECT_MAIL_CAMPAIGN_BALLPOINT_ORDER_ERROR,
  payload,
});

export const confirmDirectMailCampaignSubmissionSuccess = (payload) => ({
  type: CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION_SUCCESS,
  payload,
});

export const confirmDirectMailCampaignSubmissionError = (payload) => ({
  type: CONFIRM_DIRECT_MAIL_CAMPAIGN_SUBMISSION_ERROR,
  payload,
});

export const updateDirectMailCampaignBallpointRecipientsSuccess = (payload) => ({
  type: UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS_SUCCESS,
  payload,
});

export const updateDirectMailCampaignBallpointRecipientsError = (payload) => ({
  type: UPDATE_DIRECT_MAIL_CAMPAIGN_BALLPOINT_RECIPIENTS_ERROR,
  payload,
});

export const loadDirectMailPieceCountsSuccess = (payload) => ({
  type: LOAD_DIRECT_MAIL_PIECE_COUNTS_SUCCESS,
  payload,
});

export const loadDirectMailPieceCountsError = (payload) => ({
  type: LOAD_DIRECT_MAIL_PIECE_COUNTS_ERROR,
  payload,
});

export const loadDirectMailCostPreviewSuccess = (payload) => ({
  type: LOAD_DIRECT_MAIL_COST_PREVIEW_SUCCESS,
  payload,
});

export const loadDirectMailCostPreviewError = (payload) => ({
  type: LOAD_DIRECT_MAIL_COST_PREVIEW_ERROR,
  payload,
});

export const cancelDirectMailCampaignOrderSuccess = (payload) => ({
  type: CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS,
  payload,
});

export const cancelDirectMailCampaignOrderError = (payload) => ({
  type: CANCEL_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR,
  payload,
});


const directMailMarketing = (method, path, startType, successType, errorType, body, params) => marketing('directmail', method, path, startType, successType, errorType, body, params);


export const suppressDirectMailRtsContacts =
  (ballpointCampaignId, isAutoSuppress) => async (dispatch) => {
    try {
      const response = await apiService.post(
        "/ps/integrations/directmail/campaign/suppress-rts-contacts",
        {
          ballpointCampaignId,
          isAutoSuppress,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };


// `skipGlobalErrorHandler` defaults to false: this action is also called directly from
// Activities.js/ActivityPopup.js (Campaign Dashboard), which have no toast of their own on
// failure and rely on the generic blocking ErrorModal. Only DirectMail/index.js's caller —
// which does have its own toast on this path — opts in explicitly.
export const createDirectMailCampaign = (directMailCampaign, skipGlobalErrorHandler = false) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(directMailMarketing('post', 'campaigns', CREATE_DIRECT_MAIL_CAMPAIGN, CREATE_DIRECT_MAIL_CAMPAIGN_SUCCESS, CREATE_DIRECT_MAIL_CAMPAIGN_ERROR,
      directMailCampaign, {
      afterSuccess: (result) => {
        resolve(result?.response);
      },
      afterError: (e) => {
        reject(e);
      },
      skipGlobalErrorHandler
    }));
  });
};

/**
 * Persists opt-out changes for one or more Direct Mail contact addresses.
 *
 * The endpoint is batch-only — it always expects an array body — so even a single
 * change is sent as a one-element array instead of as its own request.
 *
 * @param {Array<{ contactId: number, addressType: string, isOptedOut: boolean }>} contactOptOuts -
 *   Opt-out entries to persist. `addressType` must be a backend address enum value
 *   (e.g. "MAILING_ADDRESS", "PROPERTY_ADDRESS").
 * @returns {Promise} Resolves with the API response, rejects on API error.
 */
export const updateDirectMailContactOptOuts = (contactOptOuts) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      [CALL_API]: {
        method: "POST",
        path: "/resource/auth/ps4/user/marketing/directmail/contact/optout",
        startType: DIRECT_MAIL_CONTACT_OPTOUT,
        successType: DIRECT_MAIL_CONTACT_OPTOUT_SUCCESS,
        errorType: DIRECT_MAIL_CONTACT_OPTOUT_ERROR,
        body: JSON.stringify(contactOptOuts),
        headers: {
          "Content-Type": "application/json",
        },
        afterSuccess: ({ response }) => resolve(response),
        afterError: (e) => reject(e),
        skipGlobalErrorHandler: true,
      },
    });
  });
};

export const updateDirectMailCampaign = (id, directMailCampaign) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(directMailMarketing('patch', `campaigns/${id}`, UPDATE_DIRECT_MAIL_CAMPAIGN, UPDATE_DIRECT_MAIL_CAMPAIGN_SUCCESS, UPDATE_DIRECT_MAIL_CAMPAIGN_ERROR,
      directMailCampaign, {
      afterSuccess: (result) => {
        resolve(result?.response);
      },
      afterError: (e) => {
        reject(e);
      },
      skipGlobalErrorHandler: true
    }));
  });
};

export const getDirectMailCampaignsByMarketingCampaignId = (marketingCampaignId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(marketing(null, 'get', `${marketingCampaignId}/directmail/campaigns`,
      LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID, LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID_SUCCESS, LOAD_DIRECT_MAIL_CAMPAIGNS_BY_MARKETING_CAMPAIGN_ID_ERROR,
      null, {
        skipGlobalErrorHandler: true,
        afterSuccess: (result) => resolve(result?.response),
        afterError: (e) => reject(e),
      }));
  });
};

export const getDirectMailCampaign = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(directMailMarketing('get', `campaigns/${id}`, LOAD_DIRECT_MAIL_CAMPAIGN, LOAD_DIRECT_MAIL_CAMPAIGN_SUCCESS, LOAD_DIRECT_MAIL_CAMPAIGN_ERROR, null,
      {
        afterSuccess: (result) => {
          resolve(result?.response);
        },
        afterError: (e) => {
          reject(e);
        },
        skipGlobalErrorHandler: true
      }));
  });
};

export const getDirectMailCampaignByBallpointCampaignId = (ballpointCampaignId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(directMailMarketing('get', `campaigns/byBallpointCampaignId/${ballpointCampaignId}`, LOAD_DIRECT_MAIL_CAMPAIGN, LOAD_DIRECT_MAIL_CAMPAIGN_SUCCESS, LOAD_DIRECT_MAIL_CAMPAIGN_ERROR, null,
      {
        afterSuccess: (result) => {
          resolve(result?.response);
        },
        afterError: (e) => {
          reject(e);
        },
        skipGlobalErrorHandler: true
      }));
  });
};

export const getDirectMailCostPreview = (directMailCampaignId) => {
  return async (dispatch) => {
    try {
      const response = await apiService.post(
        "/ps/integrations/directmail/cost-preview",
        {
          directMailCampaignId,
        }
      );

      dispatch(loadDirectMailCostPreviewSuccess(response.data));

      return response.data;
    } catch (error) {
      dispatch(loadDirectMailCostPreviewError(error.message));
      throw error;
    }
  };
};

// Returns { pieceCounts, previewRecipient } — both derived server-side from the same
// recipient-selection logic used for real Ballpoint recipient upload, so the counts
// shown to the user and the set_preview_recipient lead can't drift from what's mailed.
export const getDirectMailListPreview = (contactGroupId) => {
  return async (dispatch) => {
    try {
      const response = await apiService.get(`/ps/integrations/directmail/campaigns/contact-groups/${contactGroupId}/list-preview`);
      dispatch(loadDirectMailPieceCountsSuccess(response.data.pieceCounts));
      return response.data;
    } catch (error) {
      dispatch(loadDirectMailPieceCountsError(error.message));
      throw error;
    }
  };
};

export const createDirectMailCampaignOrder = (directMailCampaignOrder) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(directMailMarketing('post', 'campaigns/order', CREATE_DIRECT_MAIL_CAMPAIGN_ORDER, CREATE_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS, CREATE_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR,
      directMailCampaignOrder, {
      afterSuccess: (result) => {
        resolve(result?.response);
      },
      afterError: (e) => {
        reject(e);
      },
      skipGlobalErrorHandler: true
    }));
  });
};

export const updateDirectMailCampaignOrder = (orderId, ballpointOrderId, orderUpdate) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(directMailMarketing('patch', "campaigns/order?" + (orderId ? `orderId=${orderId}` : `ballpointOrderId=${ballpointOrderId}`), UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER, UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER_SUCCESS, UPDATE_DIRECT_MAIL_CAMPAIGN_ORDER_ERROR,
      orderUpdate, {
      afterSuccess: (result) => {
        resolve(result?.response);
      },
      afterError: (e) => {
        reject(e);
      },
      skipGlobalErrorHandler: true
    }));
  });
};

// The stats are stored with the id of the campaign they were requested for (see the
// LOAD_DIRECT_MAIL_CAMPAIGN_STATS reducer case). A reply, or a failure, that arrives after the user
// has moved on to another campaign is dropped, so it can neither overwrite the current campaign's
// numbers nor show an error for a campaign that is no longer on screen. A failure for the current
// campaign is re-thrown so the caller can tell the user.
export const getDirectMailCampaignStats = (marketingCampaignId) => {
  const isCurrentCampaign = (state) => selectCampaign(state).get('id') === marketingCampaignId;

  return async (dispatch, getState) => {
    dispatch(loadDirectMailCampaignStats(marketingCampaignId));

    try {
      const response = await apiService.get(`/ps/integrations/directmail/stats?marketingCampaignId=${marketingCampaignId}`);

      if (!isCurrentCampaign(getState())) return;

      dispatch(loadDirectMailCampaignStatsSuccess(response.data, marketingCampaignId));
    } catch (error) {
      if (!isCurrentCampaign(getState())) return;

      dispatch(loadDirectMailCampaignStatsError(error.message, marketingCampaignId));
      throw error;
    }
  };
};

/**
 * Requests a fresh Ballpoint embed token for the signed-in user. A plain request, not a thunk:
 * the token must never pass through Redux (redux-logger and DevTools print every action).
 * Rejects with an Error carrying our endpoint's `status` and `code` (status 0 on network error or timeout).
 */
export const requestDirectMailBallpointEmbedToken = async () => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), BALLPOINT_EMBED_TOKEN_TIMEOUT_MS);

  try {
    let response;
    try {
      response = await fetch(`${PRICING_UPDATE_URL}/ps/integrations/directmail/ballpoint-embed-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': window.appAuthToken },
        signal: controller.signal,
      });
    } catch {
      throw Object.assign(new Error('Ballpoint embed token request failed'), { status: 0, code: null });
    }

    const data = await response.json().catch(() => null);

    if (!response.ok || !data?.token) {
      throw Object.assign(new Error('Ballpoint embed token request failed'), {
        status: response.status,
        code: data?.code ?? null,
      });
    }

    return { token: data.token, expiresIn: data.expiresIn };
  } finally {
    clearTimeout(timeoutId);
  }
};

export const getDirectMailCampaignBallpointOrder = (ballpointOrderId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiService.get(`/ps/integrations/directmail/ballpoint-order?ballpointOrderId=${ballpointOrderId}`)
      .then((response) => {
        dispatch(loadDirectMailCampaignBallpointOrderSuccess(response.data));
        resolve(response.data);
      })
      .catch((error) => {
        dispatch(loadDirectMailCampaignBallpointOrderError(error.message));
        reject(error);
      });
  });
};

export const confirmDirectMailCampaignSubmission = (ballpointCampaignId, ballpointOrderIds) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiService.post('/ps/integrations/directmail/confirm-submission', {
      ballpointCampaignId,
      ballpointOrderIds,
    })
      .then((response) => {
        dispatch(confirmDirectMailCampaignSubmissionSuccess(response.data));
        resolve(response.data);
      })
      .catch((error) => {
        dispatch(confirmDirectMailCampaignSubmissionError(error.message));
        reject(error);
      });
  });
};

export const updateDirectMailCampaignBallpointRecipients = (ballpointCampaignId, contactIdsAdded, contactIdsRemoved, campaignDeltaEndpoint) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiService.post('/ps/integrations/directmail/campaign-recipients', {
      ballpointCampaignId,
      contactIdsAdded,
      contactIdsRemoved,
      campaignDeltaEndpoint,
    })
      .then((response) => {
        dispatch(updateDirectMailCampaignBallpointRecipientsSuccess(response.data));
        resolve(response.data);
      })
      .catch((error) => {
        dispatch(updateDirectMailCampaignBallpointRecipientsError(error.message));
        reject(error);
      });
  });
};

export const cancelDirectMailCampaignOrder = (ballpointOrderId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiService.post('/ps/integrations/directmail/order/cancel', {
      ballpointOrderId,
    })
      .then((response) => {
        dispatch(cancelDirectMailCampaignOrderSuccess(response.data));
        resolve(response.data);
      })
      .catch((error) => {
        dispatch(cancelDirectMailCampaignOrderError(error.message));
        reject(error);
      });
  });
};

export const saveDirectMailCampaignRts = (name, ballpointCampaignId, contactGroupId, afterSuccess, afterError) =>
  directMailMarketing(
    'put',
    'campaigns/rts',
    SAVE_DIRECT_MAIL_CAMPAIGN_RTS,
    SAVE_DIRECT_MAIL_CAMPAIGN_RTS_SUCCESS,
    SAVE_DIRECT_MAIL_CAMPAIGN_RTS_ERROR,
    { name, ballpointCampaignId, contactGroupId },
    { afterSuccess, afterError, skipGlobalErrorHandler: true }
  );
